import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import vSelect from 'vue-select'
import fetch from '@/helpers/fetch'
import { Auditoria } from '@/types/auditoria'
import TypeableDatePortal from '@/components/edit/TypeableDatePortal/index.vue'

library.add(faTrashAlt)

const emptyForm = () => ({
	group_id: null,
	request_date: '',
	source: 'carta',
	response_type: 'email',
	base_date: '',
	response_deadline: '',
	responsible_id: null,
	status: 'Pendente',
	sent_at: '',
	obs: null,
})

@Component({
	components: { TypeableDatePortal, vSelect },
})
export default class ModalAuditoria extends Vue {
	@Prop({ default: null }) auditoria!: Auditoria | null

	form: any = emptyForm()
	saving = false
	deleting = false
	confirmDelete = false
	validationMessage = ''
	notifyResponsible = true

	get isEdit(): boolean {
		return this.auditoria !== null
	}

	get title(): string {
		return this.isEdit
			? `Auditoria — ${this.auditoria?.group?.name || ''}`
			: 'Nova auditoria'
	}

	users: any[] = []
	groups: any[] = []
	loadingOptions = false

	async mounted() {
		this.loadingOptions = true
		try {
			const [usersRes, groupsRes] = await Promise.all([
				fetch.get('/api/users?name=@locatelliadv.com.br'),
				fetch.get('/api/groups'),
			])
			this.users = usersRes.data || []
			this.groups = groupsRes.data || []
		} finally {
			this.loadingOptions = false
		}
	}

	options = {
		source: [
			{ value: 'carta', text: 'Carta' },
			{ value: 'relatório', text: 'Relatório' },
		],
		response_type: [
			{ value: 'email', text: 'E-mail' },
			{ value: 'portal-terceiro', text: 'Portal terceiro' },
			{ value: 'correio', text: 'Correio' },
		],
		status: [
			{ value: 'Pendente', text: 'Pendente' },
			{ value: 'Arquivado', text: 'Arquivado' },
		],
	}

	@Watch('auditoria', { immediate: true })
	onAuditoriaChange(val: Auditoria | null) {
		this.confirmDelete = false
		if (!val) {
			this.form = emptyForm()
			return
		}
		this.form = {
			id: val.id,
			group_id: val.group?.id ?? null,
			responsible_id: val.responsible?.id ?? null,
			source: val.source,
			response_type: val.response_type,
			status: val.status,
			request_date: val.request_date,
			base_date: val.base_date,
			response_deadline: val.response_deadline,
			sent_at: val.sent_at || '',
			obs: val.obs,
		}
	}

	onShow() {
		this.confirmDelete = false
		this.saving = false
		this.deleting = false
		this.validationMessage = ''
		this.notifyResponsible = true
		if (!this.isEdit) this.form = emptyForm()
	}

	async save() {
		if (!this.isEdit) {
			const missing: any[] = []
			if (!this.form.group_id) missing.push('Cliente')
			if (!this.form.responsible_id) missing.push('Responsável')
			if (!this.form.request_date) missing.push('Data de solicitação')
			if (missing.length) {
				this.validationMessage = `Preencha os campos obrigatórios: ${missing.join(', ')}.`
				return
			}
		}
		this.validationMessage = ''
		this.saving = true
		try {
			const payload = {
				group_id: this.form.group_id,
				responsible_id: this.form.responsible_id || null,
				source: this.form.source,
				response_type: this.form.response_type,
				status: this.form.status,
				request_date: this.form.request_date || null,
				base_date: this.form.base_date || null,
				response_deadline: this.form.response_deadline || null,
				sent_at: this.form.sent_at || null,
				obs: this.form.obs || null,
			}

			if (this.isEdit) {
				await fetch.put('/api/audits/' + this.form.id, payload)
			} else {
				await fetch.post('/api/audits', { ...payload, notify_responsible: this.notifyResponsible })
			}

			this.$emit('saved', this.form)
			this.$bvModal.hide('modal-auditoria')
		} finally {
			this.saving = false
		}
	}

	async deleteAuditoria() {
		if (!this.confirmDelete) {
			this.confirmDelete = true
			return
		}
		this.deleting = true
		try {
			await fetch.delete('/api/audits/' + this.auditoria?.id)
			this.$emit('deleted', this.auditoria?.id)
			this.$bvModal.hide('modal-auditoria')
		} finally {
			this.deleting = false
			this.confirmDelete = false
		}
	}

	cancel() {
		this.$bvModal.hide('modal-auditoria')
	}
}
